enum ExpectedEffect {
    positive = 0,
    negative = 1,
    unknown = 2
}

export default ExpectedEffect;
